exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app {\n  height: 100vh;\n}\n\n.app-background {\n  position: fixed;\n  width: 3600px;\n  height: 3600px;\n  opacity: 0.3;\n  background-image: url(" + require("../../assets/images/png/textures/bglines.png") + ");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.app-background-first {\n  bottom: -1810px;\n  right: -1300px;\n  -ms-transform: rotate(54deg);\n  transform: rotate(54deg);\n}\n\n.app-background-second {\n  top: -1810px;\n  left: -1300px;\n  -ms-transform: rotate(300deg);\n  transform: rotate(300deg);\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/resolve-url-loader!./~/postcss-loader!./~/sass-loader!./src/components/app/app.component.scss
// module id = 415
// module chunks = 0